import { TIPO_IMPORTACION } from "common/components/NavBar/Components/NavBarRegistred/MenuImportacionesGenerico"
import { useGlobalContext } from "context/_globals"
import {
  ImportacionFacturaEuProps,
  ImportacionFacturaExcProps,
  ImportacionFacturaProps,
  ImportacionSageProps,
} from "context/initialStates/_globals"

export function useUploadFacturaeGlobal() {
  const [
    {
      globals: {
        importacionesGenericas,
        totalImportacionesFacturaE,
        totalImportacionesFacturaExcel,
      },
    },
    setContextStore,
  ] = useGlobalContext()

  const setImportacionesFacturaEGlobal = async (
    value: ImportacionFacturaEuProps
  ) => {
    setContextStore((prevContext) => {
      const { importacionesGenericas } = prevContext.globals

      const nuevoMensaje = value.message
        ? `${value.nombreFichero}: ${value.message}`
        : undefined

      const existe = importacionesGenericas.find(
        (item) => item.id === value.loteId
      )

      const importacionesActualizadas = existe
        ? importacionesGenericas.map((item) => {
            if (item.id !== value.loteId) return item

            const idLotes = item.idLotes ?? []
            const yaExiste = idLotes.includes(value.id)
            const nuevosIdLotes = yaExiste ? idLotes : [...idLotes, value.id]

            return {
              ...item,
              idLotes: nuevosIdLotes,
              numeroProcesadas: nuevosIdLotes.length,
              message: nuevoMensaje
                ? [...(item.message ?? []), nuevoMensaje]
                : item.message,
            }
          })
        : [
            ...importacionesGenericas,
            {
              id: value.loteId,
              nombreFichero: "FacturaE",
              numeroProcesadas: 0,
              numeroTotal: value.totalFicheros,
              idLotes: [],
              type: TIPO_IMPORTACION.FACTURAE,
              ...(nuevoMensaje && { message: [nuevoMensaje] }),
            },
          ]

      return {
        ...prevContext,
        globals: {
          ...prevContext.globals,
          importacionesGenericas: importacionesActualizadas,
        },
      }
    })
  }

  const setImportacionesFacturaExcGlobal = async (
    value: ImportacionFacturaExcProps
  ) => {
    setContextStore((prevContext) => {
      const { importacionesGenericas } = prevContext.globals

      const nuevoMensaje = value.mensaje
        ? `${value.nombreFichero}: ${value.mensaje}`
        : undefined

      const index = importacionesGenericas.findIndex(
        (item) => item.id === value.id
      )

      const newFacturaExcel =
        index !== -1
          ? importacionesGenericas.map((item, idx) => {
              if (idx !== index) return item

              const mensajeConcatenado = nuevoMensaje
                ? [...(item.message ?? ""), nuevoMensaje]
                : item.message

              return {
                ...value,
                type: TIPO_IMPORTACION.FACTURAEXCEL,
                ...(mensajeConcatenado && { message: mensajeConcatenado }),
              }
            })
          : [
              ...importacionesGenericas,
              {
                ...value,
                type: TIPO_IMPORTACION.FACTURAEXCEL,
                ...(nuevoMensaje && { message: [nuevoMensaje] }),
              },
            ]

      return {
        ...prevContext,
        globals: {
          ...prevContext.globals,
          importacionesGenericas: newFacturaExcel,
        },
      }
    })
  }
  const setImportacionesSageGlobal = async (value: ImportacionSageProps) => {
    const newValue: ImportacionFacturaProps = {
      id: value.id,
      nombreFichero: value.nombreFichero,
      message: value.exception ? [value.exception] : undefined,
      numeroProcesadas: value.lineasProcesadas,
      numeroTotal: value.lineasTotales,
      type: TIPO_IMPORTACION.SAGE,
    }

    setContextStore((prevContext) => {
      const { importacionesGenericas } = prevContext.globals
      const index = importacionesGenericas.findIndex(
        (item) => item.id === newValue.id
      )

      const newGenericas =
        index !== -1
          ? importacionesGenericas.map((item, idx) =>
              idx === index ? newValue : item
            )
          : [...importacionesGenericas, newValue]

      return {
        ...prevContext,
        globals: {
          ...prevContext.globals,
          importacionesGenericas: newGenericas,
        },
      }
    })
  }

  return {
    importacionesGenericas,
    totalImportacionesFacturaE,
    totalImportacionesFacturaExcel,
    setImportacionesFacturaEGlobal,
    setImportacionesFacturaExcGlobal,
    setImportacionesSageGlobal,
  }
}
